window.addEventListener('scroll', () => {
    const
        scrollTop = document.documentElement.scrollTop,
        scrollHeight = document.documentElement.scrollHeight,
        footer = document.querySelector('.footer').offsetHeight;

    if ((scrollTop + window.innerHeight) >= (scrollHeight - footer - 3500)) {
        FNC.paginator.loadNext();
    }

});

naja.addEventListener('success', function () {
    window.addEventListener('scroll', () => {
        const
            scrollTop = document.documentElement.scrollTop,
            scrollHeight = document.documentElement.scrollHeight,
            footer = document.querySelector('.footer').offsetHeight;

        if ((scrollTop + window.innerHeight) >= (scrollHeight - footer - 3500)) {
            FNC.paginator.loadNext();
        }

    });

})

let isLoading = false;

FNC.paginator.loadNext = () => {
    if (isLoading) {
        return;

    }

    isLoading = true

    setTimeout(function () {
        if (!_.isNull(ID['load-next'])) {
            if (parseInt(ID['load-next'].dataset.autoLoad) === 1) {
                naja.makeRequest('GET', ID['load-next'].getAttribute('href'), null, {history: true});

            }

        }

    }, 1000);

};